/* HRX Inverno — Skudo Full Body Suit landing page (page.unticut)

   Sticky header: adds the "is-stuck" class to the header once the page
   is scrolled, so the shadow appears.
*/
(function () {
  'use strict';

  var header = document.querySelector('[data-hrx-header]');
  if (!header) return;

  function onScroll() {
    header.classList.toggle('is-stuck', window.scrollY > 8);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
